import cloudflareLoader from '../../imageLoader';
import { CloudflareLoaderProps } from '../../imageLoader';

export const HERO_IMAGE_QUALITY = 80;
export const HERO_IMAGE_WIDTH = 1440;

export function heroImageCloudflareLoader(props: CloudflareLoaderProps) {
  return cloudflareLoader({
    ...props,
    width: HERO_IMAGE_WIDTH,
    quality: HERO_IMAGE_QUALITY,
  });
}
